<template>
  <main class="coming-soon">
    <img
      alt="coming-soon"
      class="position-absolute top-0 w-100 h-100"
      :src="`${useAsset('img/core-app-onboarding/coming-soon.png')}`"
    />
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import useAsset from "@/apps/core-app-onboarding/helpers/useAsset";
import { AndroidInterface } from "@/apps/core-app-onboarding/services/android.service";

declare const Android: AndroidInterface;

export default defineComponent({
  name: "ComingSoonView",
  methods: {
    hideLoader() {
      if (Android?.finishedLoading) {
        Android.finishedLoading();
      } else {
        setTimeout(() => {
          this.hideLoader();
        }, 1000);
      }
    },
  },
  setup() {
    return {
      useAsset,
    };
  },
  mounted() {
    this.hideLoader();
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
main {
  position: relative;
  & * {
    position: relative;
  }
}
.coming-soon {
  height: 100%;
  width: 100vw;
  left: 0;
  top: 0;
  overflow: hidden;
  position: fixed;
}
</style>
